const userMessages = {
    LEGACY_BAND_RISKS: 1
};
export default userMessages;